import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { useSoloModeCheck } from '@/helpers/app/hooks';
import { inboxUsersSelector } from '@/redux/app/selectors/inbox';
import { accountPrivateConversationsEnabledSelector } from '@/redux/app/selectors/settings';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';
import { UserInfoContext } from '../user/user-info';
import { UISelect } from '../ui-elements/UISelect';

export interface UserSelectProps {
  onChange: (value: string, label: string) => void;
  userId: string;
}

interface User {
  id: string,
  name: string,
  available: boolean,
  email: string,
}

export const UserSelect = ({ onChange, userId }: UserSelectProps) => {
  const { subdomain } = useContext(NavigationPaneRouteParamsContext);
  const { email, name, userId: currentUserId } = useContext(UserInfoContext);

  const users = useSelector(_.partial(inboxUsersSelector, subdomain))
    ?? { current: { id: currentUserId, email, name } };

  const privateConversationsEnabled = useSelector(accountPrivateConversationsEnabledSelector);
  const soloMode = useSoloModeCheck();
  const userList = soloMode ? [{ id: currentUserId, email, name }] : Object.values(users);
  const sortedUsers = userList.sort((a: User, b: User) => {
    if (a.email === email) return -1;
    return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1;
  });

  useEffect(() => {
    if (soloMode && !userId) onChange(currentUserId, null);
  }, []);

  return (
    <UISelect name="user_id" prompt="Anyone" value={userId} onChange={onChange}>
      {(!soloMode || !privateConversationsEnabled) && <option key="anyone" value="">Anyone</option>}
      {(!soloMode || !privateConversationsEnabled) && <option key="unassigned" value="0">Unassigned</option>}
      {sortedUsers.map((user: any) => (
        <option key={user.id} value={user.id}>{user.name}</option>
      ))}
    </UISelect>
  );
};
